import { Button } from "@/src/components/buttons";
import { Card } from "@/src/components/cards";
import { openDrawer } from "@/src/components/dialogs";
import { InfiniteFetchableList } from "@/src/components/fetchableLists";
import { Input } from "@/src/components/universalInput";
import { Reference, ReferenceCategory, referenceCategories } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getUserId, uid } from "@/src/utils/utils";
import { useState } from "react";
import { ReferenceForm } from "../referentiel/referenceForm";

export function FrequentReferencesCreationList({
  categories,
  value,
  onSelect,
}: {
  value: (Reference | null | undefined)[];
  categories: ReferenceCategory[];
  onSelect: (references: (Reference | null | undefined)[]) => void;
}) {
  const [reload, setReload] = useState(0);
  let [current, setCurrent] = useState<(Reference | null | undefined)[]>(value);
  let [searchKey, setSearchKey] = useState("");
  const [selectedCategories, setSelectedCategories] =
    useState<ReferenceCategory[]>(categories);

  async function openReferenceDialog(reference: Reference) {
    await openDrawer({
      id: "referenceDialog",
      title: "Ajouter un signe",
      content: (
        <ReferenceForm
          current={reference}
          categories={categories}
          onChange={(newValue) => {
            console.log("chabngigng", newValue);

            reference = newValue;
          }}
        />
      ),
      onConfirm: async () => {
        let inserted = await apiFetch("references", "addOne", {
          reference,
        });
        setReload(reload + 1);
      },
    });
  }

  return (
    <div className="c1 gap10">
      <Input
        name={"catégories"}
        type="select"
        options={Object.values(referenceCategories).map((category) => ({
          value: category.id,
          label: category.name,
        }))}
        value={categories[0]}
        onChange={(newValue) => {
          setSelectedCategories([newValue]);
        }}
      ></Input>
      <InfiniteFetchableList
        getFunction={(limit, offset, searchKey) => {
          return apiFetch("references", "loadMany", {
            userId: getUserId(),
            searchKey,
            limit,
            offset,
            categoriesIds: selectedCategories,
            showAll: true,
          });
        }}
        limit={40}
        queryKey={[
          "ReferencesList",
          searchKey,
          reload,
          JSON.stringify(selectedCategories),
        ]}
        searchKey={searchKey}
        onSearch={(newValue) => {
          setSearchKey(newValue || "");
        }}
        emptyChild={
          searchKey && (
            <div className="center grid c1 gap10 p20">
              Aucun élément trouvé
              <Button
                onClick={async () => {
                  let reference = {
                    name: `${searchKey || ""}`,
                  } as Reference;
                  await openReferenceDialog(reference);
                }}
              >
                Créer {searchKey}
              </Button>
            </div>
          )
        }
      >
        {(references) => (
          <div className="grid c1 gap10">
            {references?.map((reference) => {
              let referenceCategory =
                referenceCategories[reference.category || "other"];
              return (
                <Card
                  key={uid()}
                  color={
                    current?.find((item) => item?.id == reference.id) != null
                      ? "blue"
                      : "simple"
                  }
                  title={reference.name}
                  subTitle={reference.snomedConcept?.name}
                  trailing={reference.usageCount}
                  onClick={async () => {
                    if (
                      current.find((item) => item?.id == reference.id) != null
                    ) {
                      current = current.filter(
                        (item) => item?.id != reference.id
                      );
                    } else {
                      current = [...current, reference];
                    }
                    setCurrent([...current]);
                    onSelect(current);
                  }}
                >
                  <div className="gray">{referenceCategory.name}</div>
                </Card>
              );
            })}
          </div>
        )}
      </InfiniteFetchableList>
    </div>
  );
}
